import { doc, onSnapshot } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { createSharedSubscription } from "@/lib/firestore/createSharedSubscription";
import type { User } from "@amazing-wedding/shared-types";

export const currentUserSubscription = createSharedSubscription<User | null>({
  getDefault: () => null,
  attach: (uid, setSnapshot) => {
    setSnapshot({ data: null, loading: true });
    return onSnapshot(
      doc(db, "users", uid),
      (snap) => {
        if (snap.exists()) {
          setSnapshot({
            data: { id: snap.id, ...(snap.data() as Omit<User, "id">) },
            loading: false,
          });
        } else {
          setSnapshot({ data: null, loading: false });
        }
      },
      () => setSnapshot({ data: null, loading: false }),
    );
  },
});
